module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/sales-orders/receipt-confirmation/receipt-confirmation-form/receipt-confirmation-form.component.css
// module id = ./src/app/Pages/sales-orders/receipt-confirmation/receipt-confirmation-form/receipt-confirmation-form.component.css
// module chunks = main